module.exports = __webpack_public_path__ + "img/angel.8fa49dc9.jpeg";